import { render, staticRenderFns } from "./sbsp-form-file-upload.vue?vue&type=template&id=5508dab5&scoped=true&"
import script from "./sbsp-form-file-upload.vue?vue&type=script&lang=js&"
export * from "./sbsp-form-file-upload.vue?vue&type=script&lang=js&"
import style0 from "./sbsp-form-file-upload.vue?vue&type=style&index=0&id=5508dab5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5508dab5",
  null
  
)

export default component.exports